import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  MdDashboard, MdClose,
  MdSmartToy, MdUploadFile,
} from '../../utils/icons';
import { useAuthorization } from '../../auth/useAuthorization';
import { Roles, Role } from '../../auth/roles';
import logo from '../../assets/omnilinq_logo.png';
import bunzlLogo from '../../assets/bunzl-logo-small.jpg';
import './Sidebar.css';

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

// `role` gates visibility; items without a role are always shown (e.g. Dashboard
// is the shared landing page). Single source of truth for menu visibility.
interface NavItem {
  to: string;
  icon: typeof MdDashboard;
  label: string;
  role?: Role;
}

const navItems: NavItem[] = [
  { to: '/dashboard', icon: MdDashboard, label: 'Dashboard' },
  { to: '/product-agent', icon: MdSmartToy, label: 'Product Support AI Agent', role: Roles.ProductSupportAgent },
  { to: '/step-productlinq', icon: MdUploadFile, label: 'Product Data Onboarding', role: Roles.StepProductLinq },
];

const Sidebar: React.FC<SidebarProps> = ({ open, onClose }) => {
  const { hasRole } = useAuthorization();
  const visibleItems = navItems.filter((item) => !item.role || hasRole(item.role));

  return (
  <>
    {/* Mobile overlay */}
    {open && <div className="sidebar-overlay" onClick={onClose} />}

    <aside className={`sidebar ${open ? 'sidebar--open' : ''}`}>
      <div className="sidebar-logo-wrap">
        <img src={logo} alt="Bunzl" className="sidebar-logo" />
        <button className="sidebar-close-btn" onClick={onClose} aria-label="Close menu">
          <MdClose />
        </button>
      </div>

      <nav className="sidebar-nav">
        {visibleItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/dashboard'}
            className={({ isActive }) =>
              `sidebar-nav-item${isActive ? ' sidebar-nav-item--active' : ''}`
            }
            onClick={onClose}
          >
            <Icon className="sidebar-nav-icon" aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <span className="sidebar-version">OmniLinQ v1.0</span>
        <img src={bunzlLogo} alt="Bunzl" className="sidebar-bunzl-logo" />
      </div>
    </aside>
  </>
  );
};

export default Sidebar;
